import images from 'assets/images';
import { Field, Formik } from 'formik';
import { Helmet } from 'react-helmet';
import { AsyncSelectBox } from '../../components/reactstrap-formik';
import type { ICommonProps } from '../../types/propTypes';
import { SearchCodeValidationSchema } from '../../validation/search-page/search-page-validation';
import { useSearchPage } from './hooks/SearchPageHook';
import QRScanner from './QRScanner';

const initialValues = {
    unique_code: '',
};

const customStyles = {
    option: (styles, { isDisabled }) => {
        return {
            ...styles,
            color: isDisabled ? '#004687' : '',
            cursor: isDisabled ? 'not-allowed' : 'default',
        };
    },
};

const SearchStation = (props: ICommonProps) => {
    const { t, showQRScanner, privacyPolicy, loadOptions, openQRCodeScanner, handleSelect, handleQRScan } =
        useSearchPage(props);

    return (
        <>
            <Helmet>
                <title>{t<string>('searchPage.label.searchStation')}</title>
            </Helmet>
            {!showQRScanner && (
                <div className="search-page container-fluid p-0" style={{ position: 'relative' }}>
                    <div className="row h-100 no-gutters">
                        <div className="col-md search-background-block">
                            <a href="#" title={t('searchPage.label.logo')} className="instavolt-logo">
                                <img src={images.logo} alt={t('searchPage.label.logo')} />
                            </a>
                        </div>
                        <div className="col-md-auto search-section">
                            <div className="search-outer">
                                <div className="search-contain">
                                    <h1 className="title">
                                        <img src={images.logoIcon} alt={t<string>('searchPage.label.logo')} />
                                        {t<string>('searchPage.header')}
                                    </h1>

                                    <Formik
                                        initialValues={initialValues}
                                        onSubmit={() => {}}
                                        validationSchema={SearchCodeValidationSchema()}
                                    >
                                        {(props) => {
                                            const { touched, errors, setFieldTouched, setFieldValue } = props;

                                            return (
                                                <form
                                                    className="form-secondary"
                                                    onSubmit={(e) => {
                                                        e.preventDefault();
                                                    }}
                                                    autoComplete="off"
                                                    style={{ paddingTop: '20px' }}
                                                >
                                                    <Field name="unique_code">
                                                        {({ field }) => (
                                                            <div>
                                                                <AsyncSelectBox
                                                                    {...field}
                                                                    placeholder={t(
                                                                        'searchPage.placeholder.searchStation',
                                                                    )}
                                                                    className={
                                                                        touched[field.name] && errors[field.name]
                                                                            ? 'form-group is-invalid'
                                                                            : 'form-group'
                                                                    }
                                                                    loadOptions={loadOptions}
                                                                    defaultOptions={[
                                                                        {
                                                                            unique_code: t(
                                                                                'searchPage.placeholder.searchStation',
                                                                            ),
                                                                            isdisabled: true,
                                                                        },
                                                                    ]}
                                                                    isMulti={false}
                                                                    onChange={(value) => {
                                                                        setFieldValue(field.name, value);
                                                                        setFieldTouched(field.name, true);
                                                                        handleSelect(value);
                                                                    }}
                                                                    onBlur={() => setFieldTouched(field.name, true)}
                                                                    styles={customStyles}
                                                                    getOptionLabel={(opt) => {
                                                                        if (opt.isdisabled) {
                                                                            return `${opt.unique_code}`;
                                                                        } else {
                                                                            return `${opt.unique_code} - ${opt.physical_reference}`;
                                                                        }
                                                                    }}
                                                                    getOptionValue={(opt) => opt.id}
                                                                    touched={touched[field.name]}
                                                                    errors={errors[field.name]}
                                                                    isClearable={true}
                                                                    isOptionDisabled={(option) => option.isdisabled}
                                                                    maxMenuHeight={270}
                                                                />
                                                            </div>
                                                        )}
                                                    </Field>
                                                </form>
                                            );
                                        }}
                                    </Formik>
                                    <p className="text-center" style={{ paddingTop: '15px' }}>
                                        ----------------------- OR -----------------------
                                    </p>
                                    <h1 className="title">
                                        <img
                                            src={images.QRCode}
                                            alt={t('searchPage.label.qrCode')}
                                            style={{ height: '100px', cursor: 'pointer' }}
                                            onClick={() => openQRCodeScanner()}
                                            data-testid="qr-image"
                                        />
                                        <span
                                            style={{
                                                fontSize: '15px',
                                                fontWeight: 600,
                                                cursor: 'pointer',
                                            }}
                                            onClick={() => openQRCodeScanner()}
                                            data-testid="qr-span"
                                        >
                                            {t<string>('searchPage.label.scanQR')}
                                        </span>
                                    </h1>

                                    {privacyPolicy ? (
                                        <p className="copyright">
                                            {`${t<string>('searchPage.label.copyright')} | `}
                                            <a
                                                href={privacyPolicy.web_pay_policy_url}
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="privacy-policy-link"
                                            >
                                                {privacyPolicy.title}
                                            </a>
                                        </p>
                                    ) : (
                                        <p className="copyright">{t<string>('searchPage.label.copyright')}</p>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}
            {showQRScanner && <QRScanner onScan={(result) => handleQRScan(result)}></QRScanner>}
        </>
    );
};

export default SearchStation;
